import React from "react";
import { useTranslation } from "react-i18next";
import { useRetrieveCurrentPlanzone } from "@planzone/view-models";

import { usePlanzonePermissions } from "@components/permissions";
import { FilterMenu } from "@common/filterMenu";
import { FilterOptions } from "./filterOptions";
import { Props } from "./types";
import styles from "./styles.scss";

function Filters({ filter, setFilter }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isAdministrator } = usePlanzonePermissions();

  return (
    <div className={styles.filters}>
      <div className={styles.section}>
        <p className={styles.label}>{t("timeSheet.filters.title")}</p>
        <FilterMenu
          filter={filter}
          placeholder={t("timeSheet.filters.allProjects")}
          views={["zones", "projects", "projectPortfolios", "projectStatuses"]}
          openedViews={["projectStatuses"]}
          setFilter={setFilter}
        />
        <p className={styles.label}>{t("timeSheet.filters.and")} :</p>
        <FilterOptions filter={filter} onFilterChange={setFilter} />
      </div>
    </div>
  );
}

export { Filters };
